import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundHyperstarOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M12 1c1.01 0 2.02.057 3 .18v1.814a22 22 0 0 0-3-.194c-2.848 0-5.502.482-7.376 1.523C2.858 5.304 1.8 6.748 1.8 9c0 2.141.954 3.533 2.526 4.502 2.532 1.56 5.59 1.637 8.474 1.747v4.157c1.72-1.219 3.456-2.422 5.066-3.785C20.581 13.324 22.2 11.147 22.2 9H24c0 6.052-8.922 10.602-13 14v-6.019C5.351 16.765 0 14.666 0 9c0-6 6-8 12-8"
                    fill="currentColor"
                />
                <path d="M17 9.9H7V8.1h10z" fill="currentColor" />
                <path
                    d="M20.5 0A13.3 13.3 0 0 0 24 3.5 13.3 13.3 0 0 0 20.5 7 13.3 13.3 0 0 0 17 3.5 13.3 13.3 0 0 0 20.5 0"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
BubbleRoundHyperstarOutlinedSize24Glyph.displayName = 'BubbleRoundHyperstarOutlinedSize24Glyph';
